<!-- 03 — INTRODUCTION -->
<section id="about" class="expertise-section section-padding">
  <div class="container">
    <div class="expertise-grid">

      <!-- Text Column -->
      <div class="expertise-text reveal-left">
        <span class="subtitle">YOUR AMBITION. OUR EXPERTISE.</span>
        <h2 class="title">
          YOUR AMBITION.<br>
          <span class="text-gold-gradient">OUR EXPERTISE.</span>
        </h2>

        <div class="gold-divider-left"></div>

        <p class="paragraph">
          Building a home is more than a construction project. It is an investment in the way you want to live.
        </p>

        <p class="paragraph">
          At Ambition Built, we combine decades of construction experience with a personal approach to deliver homes
          that are thoughtfully designed, carefully managed and built to last.
        </p>

        <p class="paragraph">
          From the first conversation through to handover, our team works closely with you to understand your vision,
          your block, your lifestyle and your expectations.
        </p>

        <div class="quote-callout font-serif">
          "Because your home deserves more than a standard approach."
        </div>

        <div class="action-btn-row">
          <button (click)="openConsultation()" class="btn-gold">
            DISCOVER AMBITION BUILT &rarr;
          </button>
        </div>
      </div>

      <!-- Image Spotlight Column -->
      <div class="expertise-image-wrap reveal-right">
        <div class="image-frame">
          <img src="/assets/images/interior_living.jpg" alt="Luxury Architectural Interior Living Room Sydney"
            class="expertise-img">
          <div class="image-gold-accent"></div>

          <div class="experience-floating-badge reveal-scale delay-2">
            <span class="badge-num">25+</span>
            <span class="badge-lbl">YEARS OF EXCELLENCE</span>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>

<!-- 07 — THE AMBITION BUILT DIFFERENCE -->
<section class="difference-section section-padding">
  <div class="container">

    <div class="section-header text-center reveal-on-scroll">
      <span class="subtitle">THE AMBITION BUILT DIFFERENCE</span>
      <h2 class="title light">MORE THAN A BUILDER.</h2>
      <div class="gold-divider"></div>
      <p class="description light">
        We’re here to make the building process clearer, more personal and more rewarding.
      </p>
    </div>

    <div class="pillars-4-grid">
      <div class="diff-card reveal-on-scroll delay-1">
        <span class="diff-step">01</span>
        <h3 class="diff-title">LISTEN</h3>
        <p class="diff-desc">We start by understanding your vision, lifestyle, block and priorities.</p>
      </div>

      <div class="diff-card reveal-on-scroll delay-2">
        <span class="diff-step">02</span>
        <h3 class="diff-title">PLAN</h3>
        <p class="diff-desc">We help turn your ideas into a practical plan with clear expectations.</p>
      </div>

      <div class="diff-card reveal-on-scroll delay-3">
        <span class="diff-step">03</span>
        <h3 class="diff-title">BUILD</h3>
        <p class="diff-desc">Our experienced team manages the construction process with care and attention to detail.
        </p>
      </div>

      <div class="diff-card reveal-on-scroll delay-4">
        <span class="diff-step">04</span>
        <h3 class="diff-title">DELIVER</h3>
        <p class="diff-desc">We remain focused on the final result — a home you’re proud to call your own.</p>
      </div>
    </div>

    <div class="difference-footer-callout reveal-scale">
      <h3 class="callout-tagline font-serif">FROM YOUR FIRST IDEA TO THE DAY YOU TURN THE KEY.</h3>
      <button (click)="openConsultation()" class="btn-gold">
        START A CONVERSATION &rarr;
      </button>
    </div>

  </div>
</section>